module.exports = __webpack_public_path__ + "img/icon-50.f9c9f85f.svg";